export enum PlayerPosition {
	GoalKeeper = 0,
	Defender = 10,
	Midfielder = 20,
	Attacker = 30
}